import { createTheme } from "@mui/material/styles";
const STORAGE_KEY = "coremind:theme-override";
export const THEME_CHANGED_EVENT = "coremind:theme-override-changed";
export const THEME_PRESETS = {
    default: { label: "Default", primary: "#1a1a2e", secondary: "#5c6bc0" },
    slate: { label: "Slate", primary: "#3b4a5a", secondary: "#7c93a8" },
    forest: { label: "Forest", primary: "#3f6f5f", secondary: "#c98a3a" },
    ocean: { label: "Ocean", primary: "#1f5f7f", secondary: "#3aa8c9" },
};
export function loadThemeOverride() {
    if (typeof window === "undefined")
        return {};
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
    }
    catch {
        return {};
    }
}
export function saveThemeOverride(override) {
    if (typeof window === "undefined")
        return;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(override));
    window.dispatchEvent(new CustomEvent(THEME_CHANGED_EVENT, { detail: override }));
}
export function buildTheme(override) {
    const mode = override.mode ?? "light";
    const preset = THEME_PRESETS[override.presetKey ?? "default"] ?? THEME_PRESETS.default;
    return createTheme({
        palette: {
            mode,
            primary: { main: preset.primary },
            secondary: { main: preset.secondary },
        },
    });
}
